import React, { useState } from 'react';
import CustomSingleSelect, { CustomSingleSelectModel } from '../../../../components/CustomSingleSelect';
import { Helpers } from '../../../../helpers/Helpers';
import { GetAntrepoOutByIdResponseAntrepoOutVehicle, GetAntrepoOutByIdResponseAntrepoOutVehicleService } from '../../../../models/response/antrepoOut/GetAntrepoOutByIdResponse';
import { KTCard } from '../../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../../_metronic/helpers/components/KTCardBody';
import toast from "react-hot-toast";
import { ServiceService } from '../../../../services/ServiceService';
import { storeActivityIndicator, storeAreYouSureModalCallback } from '../../../../redux/reducers/authSlice';
import { GetServiceByIdResponse } from '../../../../models/response/service/GetServiceByIdResponse';
import { useDispatch } from 'react-redux';
import Box from '../../../../components/Box';
import { ServiceIncomeTypeEnum } from '../../../../models/common/Enums';
import CustomNumberInput from '../../../../components/CustomNumberInput';
import CustomSwitch from '../../../../components/CustomSwitch';
import CustomTextInput from '../../../../components/CustomTextInput';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';

interface Props {
    serviceInformationRef: any
    antrepoOutVehicles: GetAntrepoOutByIdResponseAntrepoOutVehicle[]
    antrepoOutVehicleServices: GetAntrepoOutByIdResponseAntrepoOutVehicleService[]
    setAntrepoOutVehicleServices: React.Dispatch<React.SetStateAction<GetAntrepoOutByIdResponseAntrepoOutVehicleService[]>>
    isDisabledFromLock: boolean
}

const ServicesInformation = ({
    serviceInformationRef,
    antrepoOutVehicles,
    antrepoOutVehicleServices,
    setAntrepoOutVehicleServices,
    isDisabledFromLock
}: Props) => {
    const auth = useSelector((state: RootState) => state.auth);
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const [selectedService, setSelectedService] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [quantity, setQuantity] = useState<string | undefined>(undefined);
    const [selectedMultiplier, setSelectedMultiplier] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [antrepoOutVehicleServiceId, setAntrepoOutVehicleServiceId] = useState<string | undefined>(undefined);
    const [multiplierList, setMultiplierList] = useState<CustomSingleSelectModel[]>([]);
    const [needQuantity, setNeedQuantity] = useState(false);
    const [willNotBeInvoiced, setWillNotBeInvoiced] = useState(false);
    const [willNotBeInvoicedReason, setWillNotBeInvoicedReason] = useState<string | undefined>(undefined);

    const saveItem = () => {
        if (willNotBeInvoiced && Helpers.isEmpty(willNotBeInvoicedReason)) {
            toast.error('Faturalanmama Nedeni alanını doldurunuz!')
            return;
        }

        if (Helpers.isEmpty(antrepoOutVehicleServiceId)) {
            var o: GetAntrepoOutByIdResponseAntrepoOutVehicleService = {
                antrepoOutVehicleServiceId: Helpers.generateUUID(true),
                isSelected: false,
                antrepoOutVehicleId: antrepoOutVehicles.filter(x => x.isSelected)[0].antrepoOutVehicleId,
                groupNo: antrepoOutVehicles.filter(x => x.isSelected)[0].groupNo,
                multiplierId: selectedMultiplier?.value,
                multiplierName: selectedMultiplier?.label,
                quantity: quantity,
                serviceId: selectedService?.value,
                serviceName: selectedService?.label,
                willNotBeInvoiced: willNotBeInvoiced,
                willNotBeInvoicedReason: willNotBeInvoicedReason,
            }

            setAntrepoOutVehicleServices([...antrepoOutVehicleServices, o])
        }
        else {
            setAntrepoOutVehicleServices(antrepoOutVehicleServices.map(function (x) {
                if (x.antrepoOutVehicleServiceId == antrepoOutVehicleServiceId) {
                    x.isSelected = false;
                    x.multiplierId = selectedMultiplier?.value;
                    x.multiplierName = selectedMultiplier?.label;
                    x.quantity = quantity;
                    x.serviceId = selectedService?.value;
                    x.serviceName = selectedService?.label
                    x.willNotBeInvoiced = willNotBeInvoiced;
                    x.willNotBeInvoicedReason = willNotBeInvoicedReason;
                }

                return x;
            }))
        }

        setAntrepoOutVehicleServiceId('');
        onServiceSelected(undefined);
        setQuantity('');
        setSelectedMultiplier(undefined);
        setIsOpen(false);
        setWillNotBeInvoiced(false);
        setWillNotBeInvoicedReason('');
        scrollTo();
    }

    const setUpdateItem = () => {
        var o = antrepoOutVehicleServices.filter(x => x.isSelected)[0];

        setAntrepoOutVehicleServiceId(o.antrepoOutVehicleServiceId);
        onServiceSelected(o.serviceId && o.serviceName ? { label: o.serviceName, value: o.serviceId } : undefined);
        setQuantity(o.quantity);
        setSelectedMultiplier(o.multiplierId && o.multiplierName ? { label: o.multiplierName, value: o.multiplierId } : undefined);
        setWillNotBeInvoiced(o.willNotBeInvoiced);
        setWillNotBeInvoicedReason(o.willNotBeInvoicedReason);
        setIsOpen(true);
        scrollTo();
    }

    const cancelAdding = () => {
        if (!isOpen) {
            setIsOpen(true);
            scrollTo();
            return;
        }

        setAntrepoOutVehicleServiceId('');
        onServiceSelected(undefined);
        setQuantity('');
        setSelectedMultiplier(undefined);
        setWillNotBeInvoiced(false);
        setWillNotBeInvoicedReason('');
        setIsOpen(false);
        scrollTo();
    }

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = serviceInformationRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    const setItemSelected = (_id: string) => {
        setAntrepoOutVehicleServices(antrepoOutVehicleServices.map(function (x) {
            if (x.antrepoOutVehicleServiceId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    const selectAll = () => {
        var isAllSelected = antrepoOutVehicleServices.length == antrepoOutVehicleServices.filter(x => x.isSelected).length;

        setAntrepoOutVehicleServices(antrepoOutVehicleServices.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    const deleteItems = () => {
        setAntrepoOutVehicleServices(antrepoOutVehicleServices.filter(x => !x.isSelected));
    }

    const onServiceSelected = async (selectedService: CustomSingleSelectModel | undefined) => {
        if (!selectedService) {
            setSelectedService(undefined);
            setMultiplierList([]);
            setNeedQuantity(false);
            return;
        }

        try {
            dispatch(storeActivityIndicator(true));

            var response: GetServiceByIdResponse = await ServiceService.getServiceById(selectedService.value);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setSelectedService(selectedService);
            setMultiplierList(response.data.serviceMultipliers);

            setNeedQuantity(response.data.needQuantity);

            if (!response.data.needQuantity)
                setQuantity('');
        } catch (error: any) {
            toast.error(error);
        }
        finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <div className='containerPart' ref={serviceInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Ek Hizmetler</h4>

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Hizmet Kalemi</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedService}
                                            onChange={(selectedService) => {
                                                setSelectedMultiplier(undefined);
                                                onServiceSelected(selectedService)
                                            }}
                                            onMenuOpen={() => ServiceService.getServiceList(true, [ServiceIncomeTypeEnum.EK_HIZMET])}
                                            labelName='name'
                                            valueName='serviceId'
                                            additionalValue1Name={'incomePercentageName'}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Miktar</label>
                                        <CustomNumberInput isDisabled={!needQuantity} value={quantity} setValue={setQuantity} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Birim / Çarpan</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedMultiplier}
                                            onChange={setSelectedMultiplier}
                                            onMenuOpen={async () => {
                                                return {
                                                    isSuccess: true,
                                                    data: multiplierList
                                                }
                                            }}
                                            labelName='label'
                                            valueName='value'
                                        />
                                    </div>
                                </div>

                                {
                                    auth.user.user?.data.roles.find(x => x == "Çıkış Faturalandırma İşlemi Yetkisi") && (
                                        <div className="row mt-5">
                                            <div className='col-md-4'>
                                                <Box flexDirection='row'>
                                                    <Box>
                                                        <label htmlFor="exampleFormControlInput1" className="form-label">Faturalanmayacak</label>
                                                        <CustomSwitch
                                                            setIsActive={() => {
                                                                if (willNotBeInvoiced)
                                                                    setWillNotBeInvoicedReason('');

                                                                setWillNotBeInvoiced(!willNotBeInvoiced)
                                                            }}
                                                            isActive={willNotBeInvoiced}
                                                        />
                                                    </Box>

                                                    {
                                                        willNotBeInvoiced && (
                                                            <Box ml='15px' flexGrow={1}>
                                                                <label htmlFor="exampleFormControlInput1" className="form-label required">Faturalanmama Nedeni</label>
                                                                <CustomTextInput value={willNotBeInvoicedReason} setValue={setWillNotBeInvoicedReason} />
                                                            </Box>
                                                        )
                                                    }
                                                </Box>
                                            </div>
                                        </div>
                                    )
                                }

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box onClick={saveItem} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr="5px" justifyContent="center">
                                                    <i className="text-white fa fa-check" />
                                                </Box>
                                                <Box justifyContent="center">
                                                    <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    {
                        !isDisabledFromLock && (
                            <Box className={isOpen ? "mt-5" : ""} flexDirection="row">
                                <Box onClick={antrepoOutVehicles.filter(a => a.isSelected).length == 1 ? cancelAdding : undefined} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} opacity={antrepoOutVehicles.filter(a => a.isSelected).length == 1 ? "1" : "0.5"} bg={isOpen ? 'orange' : undefined} justifyContent="center" flexDirection="row" borderRadius="4px">
                                    <Box mr="5px" justifyContent="center">
                                        <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                                    </Box>
                                    <Box justifyContent="center">
                                        <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                                    </Box>
                                </Box>

                                <Box onClick={antrepoOutVehicleServices.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={antrepoOutVehicleServices.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                                    <Box mr="5px" justifyContent="center">
                                        <i className="text-white fa fa-edit" />
                                    </Box>
                                    <Box justifyContent="center">
                                        <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                                    </Box>
                                </Box>

                                <Box onClick={antrepoOutVehicleServices.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={antrepoOutVehicleServices.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                                    <Box mr="5px" justifyContent="center">
                                        <i className="text-white fa fa-trash" />
                                    </Box>
                                    <Box justifyContent="center">
                                        <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                                    </Box>
                                </Box>
                            </Box>
                        )
                    }

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                {
                                                    !isDisabledFromLock && (
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                <input onChange={selectAll} className='form-check-input' type='checkbox' checked={antrepoOutVehicleServices.filter(x => x.isSelected).length > 0 && antrepoOutVehicleServices.filter(x => x.isSelected).length == antrepoOutVehicleServices.length} />
                                                            </label>
                                                        </div>
                                                    )
                                                }
                                            </th>
                                            <th>Grup Sıra No</th>
                                            <th>Hizmet Kalemi</th>
                                            <th>Miktar</th>
                                            <th>Birim / Çarpan</th>
                                            {auth.user.user?.data.roles.find(x => x == "Çıkış Faturalandırma İşlemi Yetkisi") && <th>Faturalanmayacak</th>}
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            antrepoOutVehicleServices.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            antrepoOutVehicleServices.map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        {
                                                            !isDisabledFromLock && (
                                                                <div className='d-flex'>
                                                                    <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                        <input onChange={() => setItemSelected(item.antrepoOutVehicleServiceId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                                    </label>
                                                                </div>
                                                            )
                                                        }
                                                    </td>
                                                    <td>{item.groupNo}</td>
                                                    <td>{item.serviceName}</td>
                                                    <td className='custom-text-right'>{item.quantity}</td>
                                                    <td>{item.multiplierName}</td>
                                                    {
                                                        auth.user.user?.data.roles.find(x => x == "Çıkış Faturalandırma İşlemi Yetkisi") && (
                                                            <td>
                                                                <Box flexDirection="row">
                                                                    <Box justifyContent="center">
                                                                        {item.willNotBeInvoiced ? <i style={{ fontSize: 20 }} className="text-success fa fa-check-circle" /> : <i style={{ fontSize: 20 }} className="text-danger fa fa-times-circle" />}
                                                                    </Box>
                                                                    {
                                                                        !Helpers.isEmpty(item.willNotBeInvoicedReason) && (
                                                                            <Box ml="5px" justifyContent="center">
                                                                                {item.willNotBeInvoicedReason}
                                                                            </Box>
                                                                        )
                                                                    }
                                                                </Box>
                                                            </td>
                                                        )
                                                    }
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default ServicesInformation;